module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page no-top-nav account-activation"
  }, [_c('Stager', {
    attrs: {
      "staging": "activation",
      "ownCurrent": _vm.current + 1,
      "ownStages": _vm.stages
    },
    on: {
      "updateCurrent": _vm.updateCurrent
    }
  }), _vm._v(" "), _c('v-carousel', {
    ref: "stageSwipe",
    class: {
      endLeft: _vm.endLeft,
      endRight: _vm.endRight
    },
    attrs: {
      "hide-delimiters": "",
      "hide-controls": "",
      "cycle": false
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, _vm._l((_vm.stages), function(stage, i) {
    return _c('v-carousel-item', {
      key: i,
      style: (("background-color: " + (stage.color))),
      attrs: {
        "src": stage.color
      },
      nativeOn: {
        "touchstart": function($event) {
          _vm.touchStart($event)
        },
        "touchend": function($event) {
          _vm.touchEnd($event)
        }
      }
    }, [_c('v-spacer'), _vm._v(" "), _c('img', {
      staticClass: "stage-img",
      class: [("stage-" + (stage.stage))],
      attrs: {
        "src": stage.image,
        "width": "50%",
        "alt": "yousound"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f24e59e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/activation/index.vue
// module id = 1643
// module chunks = 180